class ScriptConsent extends HTMLElement {
    constructor() {
        super();
        this.cookieName = 'COOKIECONSENT';
        this.cookieValue = 1; // Cookies akzeptiert
    }

    static get observedAttributes() { return ['data-consent']; }

    attributeChangedCallback(name, oldValue, newValue) {
        // Wenn das customElement das Attribut [data-consent] mit dem Wert "agree"
        // enthält, dann sollen die Scripte geladen werden.
        // Das Attribut wird dabei ausschließlich über das Event "consent-click" gesetzt.
        // Das neue Event wird in der Komponente consent-banner erzeugt und dispatched.
        if (newValue === 'agree') this.scripteLaden();
    }

    // noinspection JSUnusedGlobalSymbols
    connectedCallback() {
        // Ist der A/B-Test aktiv, können Kunden kein Banner angezeigt bekommen. In diesem Fall sollen die Skripte
        // direkt geladen werden.
        if (typeof window.heimdallActive === 'undefined' || !window.heimdallActive) {
            console.log('Heimdall-Service ist nicht aktiv => scripte laden');
            this.scripteLaden();
        } else {
            this.consentCookiePruefen();
        }
    }

    consentCookiePruefen() {
        if (this.consentCookieAkzeptiert) {
            console.log('Cookies akzeptiert => scripte laden');
            this.scripteLaden();
        } else {
            console.log('Kein Cookie gesetzt || Nur funktionale Cookies akzeptiert => scripte nicht laden');
        }
    }

    scripteLaden() {
        const erstesSkript = document.querySelector('script');
        this.skriptElement = document.createElement('SCRIPT');
        this.skriptElement.async = true;
        if (this.dataset.src === undefined) {
            this.skriptElement.innerHTML = this.innerText;
        } else {
            this.skriptElement.src = this.dataset.src;
        }
        erstesSkript.insertAdjacentElement('beforebegin', this.skriptElement);
    }

    get consentCookieAkzeptiert() {
        return document.cookie
            .split(';')
            .filter((item) => item
                .includes(`${this.cookieName}=${this.cookieValue}`)).length ?
            true :
            false;
    }
}

customElements.get('script-consent') || customElements.define('script-consent', ScriptConsent);

document.addEventListener("consent-click", (event) => {
    const scriptConsents = document.querySelectorAll('script-consent');
    scriptConsents.forEach(element => {
        const consentValue = event.target.dataset.consent;
        element.setAttribute("data-consent", consentValue);
    });
});
